
const CartServices = {
    isMobileTab(activeTab) {
        return activeTab === "mobile";
    },
    isEmailTab(activeTab) {
        return activeTab === "email";
    },  
};

export default CartServices;
